module.exports = __webpack_public_path__ + "img/6.a2ad3134.jpeg";